import _ from 'lodash';
import uuid4 from 'uuid/v4';

/*
 * Identity function returns whatever you give it
 */
export const identity = value => value;

/*
 * Takes the first element of a `list` if the list is not empty
 * and applies the `callback` on it. If no callback function
 * is given - it returns the element itself.
 * Example:
 *
 * headOption([1,2,3], (n) => n*10) == 10
 * headOption([], (n) => n*10) == undefined
 */
export const headOption = (list, callback = identity) => {
  return _.isEmpty(list) ? undefined : callback(list[0]);
};

/*
 * Equivalent of Option.map() function
 * If `value` is undefined or null => do nothing
 * if `value` is something else => execute callback
 * Example:
 *
 * const a = maybeAValue ? func(maybeAValue) : null
 * const a = callIfExists(maybeAValue, func)
 */
export const callIfExists = (value, callback) =>
  _.isNil(value) ? null : callback(value);

export const attachUuidKey = obj => ({...obj, uuid: uuid4()});

// Just a better understood name for partition
export const splitListBy = (list, predicate) => _.partition(list, predicate);

export const toBoolean = (value: any) => {
  if (value) {
    return value.toString() != 'false';
  }

  return false;
};

export const humanReadableBoolean = boolean => {
  if (boolean) {
    return 'Yes';
  }
  return 'No';
};
